import { useI18n } from "@/locales/i18n-provider";
import { useEmbeddedHost } from "../embedded-host-provider";

/**
 * 嵌入首页：当前业务对象的关联工单（设计 §5.3、§11）。
 *
 * TODO(M3-4)：接 `GET /api/admin/integration/contexts/{systemCode}/{entityType}/{entityId}/tickets`。
 * 该端点依赖 `ILinkedEntityProvider` 适配层，当前仓库零实现（AR-33、阻塞项 5）。
 * 在它就绪前这里只展示宿主给的定位信息，并明确告诉用户"还看不到关联工单"，
 * 而不是伪造一个空列表——父页面传入的 `entityId` 不是可信业务事实，
 * 不能因为它存在就假装解析成功。
 */
export default function EmbeddedContextHomePage() {
  const { t } = useI18n();
  const { businessContext } = useEmbeddedHost();

  return (
    <section className="px-4 py-5">
      <h2 className="text-sm font-semibold text-foreground">{t("embedded.context.title")}</h2>

      {businessContext ? (
        <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
          <dt className="text-muted-foreground">{t("embedded.context.systemCode")}</dt>
          <dd className="text-foreground">{businessContext.systemCode}</dd>
          <dt className="text-muted-foreground">{t("embedded.context.entityType")}</dt>
          <dd className="text-foreground">{businessContext.entityType}</dd>
          <dt className="text-muted-foreground">{t("embedded.context.entityId")}</dt>
          <dd className="break-all text-foreground">{businessContext.entityId}</dd>
        </dl>
      ) : (
        <p className="mt-3 text-sm leading-6 text-muted-foreground">{t("embedded.context.waiting")}</p>
      )}

      <p className="mt-6 rounded-lg border border-dashed px-4 py-3 text-sm leading-6 text-muted-foreground">{t("embedded.context.providerPending")}</p>
    </section>
  );
}
